module.exports = "<div class=\"lui-table__wrapper\" seedelement><slot></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-table/theme/lui-table.html
// module id = 370
// module chunks = 0 1 24